// 组织管理模块页面级国际化
export default {
  // ─── 通用 ──────────────────────────────────────────────────────────────
  'org.common.status.enable': '启用',
  'org.common.status.disable': '禁用',
  'org.common.status.enabled': '启用中',
  'org.common.status.disabled': '未启用',
  'org.common.status.active': '激活',
  'org.common.status.inactive': '未激活',
  'org.common.status.normal': '正常',
  'org.common.confirm': '确认',
  'org.common.cancel': '取消',
  'org.common.save': '保存',
  'org.common.reset': '重置',
  'org.common.submit': '提交',
  'org.common.export': '导出',
  'org.common.export.loading': '正在获取导出数据，请稍候…',
  'org.common.export.fetchFail': '获取导出数据失败',
  'org.common.export.noData': '暂无数据可导出',
  'org.common.export.success': '导出成功',
  'org.common.export.fail': '导出失败，请重试',
  'org.common.export.queryCondition': '查询条件',
  'org.common.export.totalRecords': '共 {count} 条记录',
  'org.common.status.updating': '正在更新状态',
  'org.common.status.updateSuccess': '更新成功',
  'org.common.status.updateFail': '更新失败，请重试',
  'org.common.exportOptionExcel': 'Excel (.xlsx)',
  'org.common.exportOptionCsv': 'CSV (.csv)',
  'org.common.exportOptionPdf': 'PDF (.pdf)',
  'org.common.print': '打印',
  'org.common.new': '新建',
  'org.common.edit': '编辑',
  'org.common.backToList': '返回列表',
  'org.common.field.status': '状态',
  'org.common.field.remark': '备注',
  'org.common.field.creator': '创建人',
  'org.common.field.createTime': '创建时间',
  'org.common.field.updateTime': '更新时间',
  'org.common.field.sort': '排序号',
  'org.common.field.operation': '操作',
  'org.common.label.role': '角色',
  'org.common.label.creator': '创建者',
  'org.common.label.company': '公司',
  'org.common.label.dept': '部门',
  'org.common.sex.unknown': '未知',
  'org.common.sex.male': '男',
  'org.common.sex.female': '女',

  // ─── 公司管理 ──────────────────────────────────────────────────────────────
  'org.company.title': '公司管理',
  'org.company.new': '新建公司',
  'org.company.edit.title': '编辑公司信息',
  'org.company.setting.title': '设置',
  'org.company.total': '总公司数',
  'org.company.filter.jointQuery': '联合查询',
  'org.company.filter.keyword.placeholder': '请输入关键词(公司/分组标签)',
  'org.company.filter.tagLabel': '分组标签',
  'org.company.filter.name.placeholder': '请输入公司名称',
  'org.company.filter.tag.placeholder': '请输入分组标签',
  'org.company.field.id': '公司ID',
  'org.company.field.name': '公司名称',
  'org.company.field.code': '公司代码',
  'org.company.field.group': '分组标签',
  'org.company.field.sort': '排序号',
  'org.company.field.userCount': '公司人数',
  'org.company.form.name.label': '公司名称',
  'org.company.form.name.required': '请输入公司名称',
  'org.company.form.code.label': '公司代号',
  'org.company.form.code.required': '请输入公司代号',
  'org.company.form.group.label': '分组标签',
  'org.company.form.folderTemplate.label': '文件夹模板',
  'org.company.form.folderTemplate.placeholder': '请选择文件夹模板',
  'org.company.form.sort.label': '排序号',
  'org.company.form.sort.required': '请输入排序号',
  'org.company.form.status.placeholder': '请选择状态',
  'org.company.form.remark.label': '备注',
  'org.company.form.remark.placeholder': '请输入备注',
  'org.company.error.notFound': '未找到该公司信息',
  'org.company.error.fetchFail': '获取公司信息失败',
  'org.company.setting.usedToken': '当前已使用 Token 额度',
  'org.company.setting.daily': '日用量',
  'org.company.setting.weekly': '周用量',
  'org.company.setting.monthly': '月用量',
  'org.company.setting.resetConfirm': '确认重置已使用额度为 0？',
  'org.company.setting.companyQuota': '公司配额',
  'org.company.setting.userDefaultQuota': '用户默认配额',
  'org.company.setting.dailyQuota': '日配额（tokens）',
  'org.company.setting.weeklyQuota': '周配额（tokens）',
  'org.company.setting.monthlyQuota': '月配额（tokens）',
  'org.company.setting.zeroUnlimited': '0表示不限制',
  'org.company.setting.saveSuccess': '配置保存成功',
  'org.company.setting.saveFail': '配置保存失败',
  'org.company.setting.resetSuccess': '已使用额度重置成功',
  'org.company.setting.resetFail': '重置失败，请重试',
  'org.company.setting.fetchFail': '获取配置信息失败',

  // ─── 部门管理 ──────────────────────────────────────────────────────────────
  'org.dept.title': '部门管理',
  'org.dept.new': '新建部门',
  'org.dept.edit.title': '编辑部门信息',
  'org.dept.total': '总部门数',
  'org.dept.field.id': '部门ID',
  'org.dept.field.name': '部门名称',
  'org.dept.field.company': '所属公司',
  'org.dept.field.deptCount': '部门人数',
  'org.dept.form.name.label': '部门名称',
  'org.dept.form.name.required': '请输入部门名称',
  'org.dept.form.name.placeholder': '请输入部门名称',
  'org.dept.form.company.label': '所属公司',
  'org.dept.form.company.required': '请选择所属公司',
  'org.dept.form.company.placeholder': '请选择公司',
  'org.dept.form.sort.label': '排序',
  'org.dept.form.sort.placeholder': '请输入排序',
  'org.dept.form.remark.label': '备注',
  'org.dept.form.remark.placeholder': '请输入备注',
  'org.dept.error.notFound': '未找到该部门信息',
  'org.dept.error.fetchFail': '获取部门信息失败',
  'org.dept.filter.keyword.placeholder': '请输入关键词',
  'org.dept.filter.name.placeholder': '请输入部门名称',
  'org.dept.filter.company.placeholder': '请选择所属公司',

  // ─── 角色管理 ──────────────────────────────────────────────────────────────
  'org.role.title': '角色管理',
  'org.role.new': '新建角色',
  'org.role.add.title': '角色新增',
  'org.role.edit.title': '角色编辑',
  'org.role.edit.breadcrumb': '编辑角色',
  'org.role.total': '总角色数',
  'org.role.field.id': '角色ID',
  'org.role.field.name': '角色名称',
  'org.role.field.ownerCompany': '权属公司',
  'org.role.field.description': '描述 (可选)',
  'org.role.field.basicInfo': '基本信息',
  'org.role.form.name.label': '角色名称',
  'org.role.form.name.required': '请输入角色名称',
  'org.role.form.name.placeholder': '请输入角色名称',
  'org.role.form.description.label': '描述 (可选)',
  'org.role.form.description.placeholder': '请输入描述',
  'org.role.perm.functionTree': '功能树',
  'org.role.perm.permCode': '权限码',
  'org.role.perm.view': '查看',
  'org.role.perm.edit': '编辑',
  'org.role.perm.delete': '删除',
  'org.role.perm.add': '新增',
  'org.role.perm.export': '导出',
  'org.role.perm.print': '打印',
  'org.role.perm.searchPlaceholder': '输入菜单名称或权限码搜索',
  'org.role.action.batchEnable': '批量启用',
  'org.role.action.batchDisable': '批量禁用',
  'org.role.action.batchOperation': '批量操作',
  'org.role.action.copyRole': '复制角色',
  'org.role.action.select': '选择',
  'org.role.action.queryRelated': '查询关联',
  'org.role.error.noRoleId': '参数错误：缺少角色ID',
  'org.role.error.fetchFail': '获取角色详情失败',
  'org.role.error.updateFail': '更新失败',
  'org.role.error.saveFail': '保存失败',
  'org.role.form.company.required': '请选择权属公司',
  'org.role.form.company.placeholder': '请选择权属公司',
  'org.role.form.remark.placeholder': '这里显示至多三行',
  'org.role.filter.keyword.placeholder': '请输入关键词(角色/创建者/公司)',
  'org.role.filter.createBy.placeholder': '请选择创建者',
  'org.role.filter.company.placeholder': '请选择公司',

  // v01b13 知识库授权(角色侧入口)
  'org.role.kbAuth.cardTitle': '知识库授权',
  'org.role.kbAuth.available': '可选知识库(按公司)',
  'org.role.kbAuth.granted': '已授权',
  'org.role.kbAuth.saved': '保存成功',
  'org.role.kbAuth.bypassed': '该角色默认可访问全部知识库,无需配置',
  'org.role.kbAuth.noCompany': '未挂公司',

  // ─── 用户管理 ──────────────────────────────────────────────────────────────
  'org.user.title': '用户管理',
  'org.user.new': '新建用户',
  'org.user.copy': '复制用户',
  'org.user.edit.title': '编辑用户',
  'org.user.edit.subtitle': '带 * 为必填项',
  'org.user.section.basic': '基础信息',
  'org.user.section.org': '组织与权限',
  'org.user.section.contact': '联系方式',
  'org.user.form.weightHint': '权重值需小于 {max}',
  'org.user.detail.title': '用户详情',
  'org.user.total': '总用户数',
  'org.user.view.card': '卡片',
  'org.user.view.list': '列表',
  'org.user.field.id': '用户ID',
  'org.user.field.account': '账号名',
  'org.user.field.nickname': '用户昵称',
  'org.user.field.email': '电子邮箱',
  'org.user.field.company': '所属公司',
  'org.user.field.dept': '所属部门',
  'org.user.field.deptShort': '部门',
  'org.user.field.phone': '电话号码',
  'org.user.field.phone1': '备用电话号码',
  'org.user.col.phone1': '电话号码1',
  'org.user.col.phone2': '电话号码2',
  'org.common.search.placeholder': '请输入',
  'org.user.field.weight': '账号权重',
  'org.user.field.sex': '性别',
  'org.user.form.account.required': '请输入账号名',
  'org.user.form.account.maxLen': '账号名最长为 50 位',
  'org.user.form.account.pattern': '账号名仅支持字母、数字以及 .-_ 符号',
  'org.user.form.account.placeholder': '请输入账号名',
  'org.user.form.nickname.required': '请输入用户昵称',
  'org.user.form.nickname.placeholder': '请输入用户昵称',
  'org.user.form.email.required': '请输入电子邮箱',
  'org.user.form.email.invalid': '请输入有效的邮箱地址',
  'org.user.form.email.placeholder': '请输入电子邮箱',
  'org.user.form.sex.required': '请选择性别',
  'org.user.form.status.required': '请选择状态',
  'org.user.form.company.placeholder': '请输入公司名称进行搜索',
  'org.user.form.company.required': '请选择所属公司',
  'org.user.form.dept.placeholder': '请选择部门',
  'org.user.form.phone.placeholder': '请输入电话号码',
  'org.user.form.phone1.placeholder': '请输入备用电话号码',
  'org.user.form.weight.required': '请输入账号权重',
  'org.user.form.weight.placeholder': '请输入账号权重',
  'org.user.form.weight.label': '账号权重(只能小于{max})',
  'org.user.filter.keyword.placeholder': '请输入关键词(账号/昵称/邮箱/公司/部门)',
  'org.user.filter.company.placeholder': '请输入所属公司',
  'org.user.filter.phone1.placeholder': '请输入电话号码1',
  'org.user.filter.phone2.placeholder': '请输入电话号码2',
  'org.user.filter.nickname.placeholder': '请选择或输入用户昵称',
  'org.user.filter.account.placeholder': '请选择或输入账号名',
  'org.user.filter.email.placeholder': '请选择或输入电子邮箱',
  'org.user.filter.companySelect.placeholder': '请选择或输入所属公司',
  'org.user.filter.dept.placeholder': '请选择或输入所属部门',
  'org.user.add.success': '添加成功',
  'org.user.add.fail': '添加失败',
  'org.user.add.copyFetchFail': '获取复制用户信息失败',
  'org.user.add.systemError': '系统错误，请稍后再试',
  'org.user.add.modalTitle': '用户添加成功',
  'org.user.add.modalDesc': '以下是新创建用户的详细信息，请妥善保存初始密码。',
  'org.user.add.copyAccountPwd': '一键复制账号密码',
  'org.user.add.close': '关闭',
  'org.user.add.copyText': '账号：{account}\n密码：{password}',
  'org.user.add.copySuccess': '账号和密码已成功复制到剪贴板',
  'org.user.add.copyFail': '复制失败，请手动复制',
  'org.user.add.desc.account': '用户账号',
  'org.user.add.desc.initPwd': '初始密码',
  'org.user.add.desc.phone': '手机号码',
  'org.user.add.desc.createTime': '创建时间',
  'org.user.add.subtitle': '带 * 为必填项，提交后系统将自动生成初始密码',
  'org.user.edit.success': '更新成功',
  'org.user.edit.fail': '更新失败',
  'org.user.edit.fetchFail': '获取用户信息失败',
  'org.user.edit.noId': '未获取到用户ID',
  'org.user.edit.systemError': '系统错误，请稍后再试',
  'org.user.action.editProfile': '编辑资料',
  'org.user.action.permManage': '权限管理',
  'org.user.action.quota': '配额',
  'org.user.action.copy': '复制',
  'org.user.action.enable': '启用',
  'org.user.action.disable': '禁用',
  'org.user.action.batchImport': '批量导入',
  'org.user.detail.noData': '暂无数据',
  'org.user.detail.back': '返回',
  'org.user.detail.roleInfo': '角色信息',
  'org.user.detail.roleField': '角色',

  // 批量导入
  'org.user.batchImport.title': '批量导入用户',
  'org.user.batchImport.downloadTemplate': '下载导入模板',
  'org.user.batchImport.uploadCard': '上传导入文件',
  'org.user.batchImport.guide.title': '导入说明',
  'org.user.batchImport.guide.basicRequire': '基本要求',
  'org.user.batchImport.guide.req1': '请先下载模板，不要修改第一行列头，从第二行开始填写数据',
  'org.user.batchImport.guide.req2': '支持 .xlsx、.xls 格式，选择文件后自动开始导入',
  'org.user.batchImport.guide.req3': '导入成功后系统自动生成初始密码，将在结果页展示，请截图保存并告知用户',
  'org.user.batchImport.guide.fieldDesc': '字段说明（共 10 列）',
  'org.user.batchImport.guide.colName': '列名',
  'org.user.batchImport.guide.colRequired': '是否必填',
  'org.user.batchImport.guide.colRule': '填写规则',
  'org.user.batchImport.guide.required': '必填',
  'org.user.batchImport.guide.optional': '选填',
  'org.user.batchImport.guide.row.account.rule': '唯一，不可与已有账号重复',
  'org.user.batchImport.guide.row.nickname.rule': '显示名称，允许重复',
  'org.user.batchImport.guide.row.status.rule': '1 = 启用（默认），0 = 禁用',
  'org.user.batchImport.guide.row.company.rule': '须与系统中已存在的公司名称完全一致',
  'org.user.batchImport.guide.row.dept.rule': '须与系统中已存在的部门名称完全一致，不填则不分配部门',
  'org.user.batchImport.guide.row.weight.rule': '正整数，数值越大操作权限越高，不填使用默认值',
  'org.user.batchImport.guide.row.email.rule': '有效邮箱格式，用于接收通知',
  'org.user.batchImport.guide.row.phone.rule': '11 位数字',
  'org.user.batchImport.guide.row.sex.rule': 'M = 男，F = 女，不填则为未知',
  'org.user.batchImport.upload.dragging': '点击或拖拽文件到此区域上传',
  'org.user.batchImport.upload.hint': '选择文件后将自动开始导入，支持 .xlsx、.xls 格式',
  'org.user.batchImport.upload.spinning': '正在上传并导入，请稍候...',
  'org.user.batchImport.result.success': '导入成功，共导入 {count} 条记录',
  'org.user.batchImport.result.partial': '导入完成：成功 {count} 条，部分数据导入失败',
  'org.user.batchImport.result.continue': '继续导入',
  'org.user.batchImport.result.backToList': '返回用户列表',
  'org.user.batchImport.result.failDetail': '失败明细',
  'org.user.batchImport.result.successList': '成功导入的用户',
  'org.user.batchImport.result.countUnit': '条',
  'org.user.batchImport.result.pwdWarning': '请及时记录初始密码并告知用户，页面关闭后将无法再次查看',
  'org.user.batchImport.result.pwdNotice': '初始密码仅在此页面显示一次，请截图或复制保存后再离开',
  'org.user.batchImport.error.importFail': '导入失败，请重试',
  'org.user.batchImport.error.uploadFail': '上传失败，请检查网络后重试',
  'org.user.batchImport.col.account': '账号名',
  'org.user.batchImport.col.nickname': '用户昵称',
  'org.user.batchImport.col.email': '电子邮箱',
  'org.user.batchImport.col.initPwd': '初始密码',

  // 配额弹窗
  'org.user.quota.title': '配额管理',
  'org.user.quota.usedToken': '当前已使用 Token 额度',
  'org.user.quota.daily': '日用量',
  'org.user.quota.weekly': '周用量',
  'org.user.quota.monthly': '月用量',
  'org.user.quota.resetConfirm': '确认重置已使用额度为 0？',
  'org.user.quota.reset': '重置',
  'org.user.quota.dailyLimit': '日配额（tokens）',
  'org.user.quota.weeklyLimit': '周配额（tokens）',
  'org.user.quota.monthlyLimit': '月配额（tokens）',
  'org.user.quota.zeroUnlimited': '0 表示不限制',
  'org.user.quota.saveSuccess': '配额保存成功',
  'org.user.quota.saveFail': '保存失败，请重试',
  'org.user.quota.fetchFail': '获取配额信息失败',
  'org.user.quota.fetchFail2': '获取配额信息失败，请重试',
  'org.user.quota.resetSuccess': '已使用额度重置成功',
  'org.user.quota.resetFail': '重置失败，请重试',

  // 角色选择弹窗
  'org.user.roleModal.title': '选择角色',
  'org.user.roleModal.ok': '确认选择',
  'org.user.roleModal.headerTitle': '角色列表',
  'org.user.roleModal.selected': '已选择 {count} 项',
  'org.user.roleModal.col.name': '角色名称',
  'org.user.roleModal.col.status': '状态',
  'org.user.roleModal.col.remark': '备注',
  'org.user.roleModal.col.creator': '创建者',
  'org.user.roleModal.col.createTime': '创建时间',
  'org.user.roleModal.status.normal': '正常',
  'org.user.roleModal.status.disabled': '禁用',
  'org.user.roleModal.name.placeholder': '请输入角色名称',
  'org.user.roleModal.search.placeholder': '请输入关键词(角色/创建者/公司)',

  // 私有权限弹窗
  'org.user.permModal.title': '配置私有权限',
  'org.user.permModal.searchPlaceholder': '输入菜单名称或权限码搜索',
  'org.user.permModal.added': '私有新增',
  'org.user.permModal.removed': '私有移除',
  'org.user.permModal.error.noId': '参数错误：缺少用户ID或角色ID',
  'org.user.permModal.error.fetchFail': '获取权限数据失败',
  'org.user.permModal.saveSuccess': '保存成功',
  'org.user.permModal.saveFail': '保存失败',

  // 用户详情抽屉
  'org.user.drawer.title': '用户详情',
  'org.user.drawer.tab.basic': '基础信息',
  'org.user.drawer.tab.roles': '角色信息',
  'org.user.drawer.col.roleName': '角色名称',
  'org.user.drawer.col.status': '状态',
  'org.user.drawer.col.remark': '备注',
  'org.user.drawer.status.active': '激活',
  'org.user.drawer.status.inactive': '未激活',
  'org.user.drawer.status.enabled': '启用',
  'org.user.drawer.status.disabled': '禁用',
  'org.user.drawer.noRoles': '暂无角色',
  'org.user.drawer.field.account': '账号名',
  'org.user.drawer.field.nickname': '用户昵称',
  'org.user.drawer.field.email': '电子邮箱',
  'org.user.drawer.field.phone': '手机号码',
  'org.user.drawer.field.sex': '性别',
  'org.user.drawer.field.company': '所属公司',
  'org.user.drawer.field.dept': '部门',
  'org.user.drawer.field.weight': '账号权重',
  'org.user.drawer.field.createTime': '创建时间',
  'org.user.drawer.field.updateTime': '更新时间',

  // 用户选择弹窗
  'org.user.userModal.title': '引用权限',
  'org.user.userModal.ok': '确认选择',
  'org.user.userModal.headerTitle': '用户列表',
  'org.user.userModal.selected': '已选择 {count} 项',
  'org.user.userModal.col.account': '账号',
  'org.user.userModal.col.nickname': '用户昵称',
  'org.user.userModal.col.email': '电子邮箱',
  'org.user.userModal.col.status': '状态',
  'org.user.userModal.col.company': '所属公司',
  'org.user.userModal.col.dept': '所属部门',
  'org.user.userModal.col.creator': '创建者',
  'org.user.userModal.col.weight': '账号权重',
  'org.user.userModal.status.enabled': '启用中',
  'org.user.userModal.status.disabled': '未启用',
  'org.user.userModal.nickname.placeholder': '请输入用户昵称',
  'org.user.userModal.search.placeholder': '请输入关键词(账号/昵称/邮箱/公司/部门)',

  // 用户卡片
  'org.user.card.status.active': '激活',
  'org.user.card.status.inactive': '未激活',
  'org.user.card.action.lock': '锁定',
  'org.user.card.action.enable': '启用',
  'org.user.card.action.perm': '权限',
  'org.user.card.action.edit': '编辑',
  'org.user.card.noPermission': '权限不足',
  'org.user.card.nickname': '昵称',
  'org.user.card.companyName': '公司名称',

  // 用户权限管理页
  'org.user.perm.pageTitle': '用户权限管理',
  'org.user.perm.isManager': '管理员',
  'org.user.perm.createdAt': '创建于',
  'org.user.perm.statusActive': '激活',
  'org.user.perm.statusInactive': '未激活',
  'org.user.perm.account': '账号',
  'org.user.perm.company': '所属公司',
  'org.user.perm.phone': '手机号',
  'org.user.perm.sex': '性别',
  'org.user.perm.col.roleName': '角色名称',
  'org.user.perm.col.roleId': '角色ID',
  'org.user.perm.col.status': '状态',
  'org.user.perm.col.remark': '备注',
  'org.user.perm.col.grantor': '授权人',
  'org.user.perm.col.grantTime': '授权时间',
  'org.user.perm.col.ownerCompany': '权属公司',
  'org.user.perm.col.operation': '操作',
  'org.user.perm.status.normal': '正常',
  'org.user.perm.status.disabled': '禁用',
  'org.user.perm.action.remove': '移除',
  'org.user.perm.action.customize': '自定义',
  'org.user.perm.action.restore': '恢复',
  'org.user.perm.btn.add': '添加',
  'org.user.perm.btn.reference': '引用权限',
  'org.user.perm.btn.remove': '移除',
  'org.user.perm.btn.cancelSelect': '取消选择',
  'org.user.perm.selected': '已选择 {count} 项',
  'org.user.perm.setManager': '设为管理员',
  'org.user.perm.cancelManager': '取消管理员',
  'org.user.perm.resetPwd': '重置密码',
  'org.user.perm.confirm.setManager': '确认设为管理员',
  'org.user.perm.confirm.cancelManager': '确认取消管理员',
  'org.user.perm.confirm.setManagerContent': '确定要将用户 {name} 设为系统管理员吗？',
  'org.user.perm.confirm.cancelManagerContent': '确定要取消用户 {name} 的管理员权限吗？',
  'org.user.perm.confirm.setManagerSuccess': '已设为系统管理员',
  'org.user.perm.confirm.cancelManagerSuccess': '已取消管理员权限',
  'org.user.perm.confirm.resetPwd': '确认重置密码',
  'org.user.perm.confirm.resetPwdContent': '确定要重置用户 {account} 的密码吗？',
  'org.user.perm.resetPwd.success': '密码重置成功',
  'org.user.perm.resetPwd.account': '账号：',
  'org.user.perm.resetPwd.newPwd': '新密码：',
  'org.user.perm.resetPwd.tip': '请务必妥善保管新密码，建议登录后立即修改。',
  'org.user.perm.resetPwd.ok': '知道了',
  'org.user.perm.resetPwd.failPrefix': '密码重置失败：',
  'org.user.perm.resetPwd.fail': '密码重置失败',
  'org.user.perm.remove.confirm': '确认移除',
  'org.user.perm.remove.content': '确定要移除选中的 {count} 个角色吗？此操作不可撤销。',
  'org.user.perm.remove.loading': '正在移除...',
  'org.user.perm.remove.success': '移除成功',
  'org.user.perm.remove.fail': '移除失败',
  'org.user.perm.restore.confirm': '确认恢复',
  'org.user.perm.restore.content': '确定要清空该角色的用户私有化权限吗？恢复后将使用角色的默认权限。',
  'org.user.perm.restore.loading': '正在恢复...',
  'org.user.perm.restore.success': '恢复成功',
  'org.user.perm.restore.fail': '恢复失败',
  'org.user.perm.reference.loading': '正在引用 {count} 个用户的权限...',
  'org.user.perm.reference.success': '成功引用 {count} 个用户的权限',
  'org.user.perm.reference.fail': '引用权限失败，请稍后重试',
  'org.user.perm.reference.noSelect': '请选择要引用的用户',
  'org.user.perm.role.loading': '正在为用户分配 {count} 个角色...',
  'org.user.perm.role.success': '成功为用户分配 {count} 个角色',
  'org.user.perm.role.fail': '角色分配失败，请稍后重试',
  'org.user.perm.role.noSelect': '请选择至少一个角色',
  'org.user.perm.error.noUserId': '未获取到用户ID',
  'org.user.perm.error.fetchFail': '获取用户信息失败',
  'org.user.perm.error.opFail': '操作失败',
  'org.user.perm.error.opFail2': '操作失败，请稍后重试',
  'org.user.perm.perm.saveSuccess': '权限配置已更新',
};
